const dl = window.dataLayer;
export const dlDispatchAmplEvent = (type, context = {}) => {
    dl.push({ event_context: null });
    dl.push({
        event: 'amplitude_user_event',
        ampl_event_type: type,
        event_context: context
    });
};
